import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import pages from "../utils/pages";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = ({active, setActive}) => {

  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const chiudiNavbar = () => {
    setActive(false);
  }
  
  return <Wrapper className={active ? 'active' : ''} style={isMobile ? {width: '80%'} : {width: '40%'}}>
            <div className="inside">
                <ul>
                    {
                        pages.map((page) => {
                            return <li key={page.id}>
                                <Link to={page.path} onClick={chiudiNavbar} className="link">
                                    <p>{t(page.text)}</p>
                                </Link>
                            </li>
                        })
                    }
                </ul>
            </div> 
    </Wrapper>
}

export default Navbar;

const Wrapper = styled.nav`
    position: fixed;
    top: 0px;
    right: 0px;
    height: 100%;
    background-color: var(--logo);
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translate(100%, 0%);
    transition: transform 0.5s ease-in-out;
    &.active {
        transform: translate(0%, 0%);
    }
    .inside {
        height: 75%;
        width: 75%;
        ul {
            list-style: none;
            li {
                &:not(:first-child) {
                    padding-top: 20px;
                }
                .link {
                    padding: 5px 0px;
                    font-size: 20px;
                    color: white;
                }
            }
        }
    }
`